import axios from 'axios';

export const subscriptionManagementApi = {
  /**
   * Obtenir le statut du compte utilisateur
   */
  async getAccountStatus() {
    try {
      const response = await axios.get('/payment/subscription/status');
      return { success: true, data: response.data };
    } catch (error) {
      const errorCode = error.response?.data?.error;
      const errorMessage = error.response?.data?.message || error.message;
      return { 
        success: false, 
        error: errorMessage,
        errorCode: errorCode,
        email: error.response?.data?.email
      };
    }
  },

  /**
   * Résilier un abonnement
   */
  async cancelSubscription(data) {
    try {
      const response = await axios.post('/payment/subscription/cancel', data);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.message || error.message };
    }
  },

  /**
   * Annuler une résiliation programmée
   */
  async revokeCancellation() {
    try {
      const response = await axios.post('/payment/subscription/revoke-cancellation');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.response?.data?.message || error.message
      };
    }
  },

  /**
   * Réactiver un compte suspendu
   */
  async reactivateAccount(paymentMethodId) {
    try {
      const response = await axios.post('/payment/subscription/reactivate', {
        payment_method_id: paymentMethodId
      });
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.message || error.message };
    }
  },

  /**
   * Mettre à jour le mode de paiement
   */
  async updatePaymentMethod(paymentMethodId) {
    try {
      const response = await axios.put('/payment/subscription/payment-method', {
        payment_method_id: paymentMethodId
      });
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.message || error.message };
    }
  },

  /**
   * Obtenir les statistiques des comptes (admin)
   */
  async getAccountStats() {
    try {
      const response = await axios.get('/payment/subscription/stats');
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.message || error.message };
    }
  }
};

export default subscriptionManagementApi;